/* eslint-disable */
const withHeaders = ['/template/create'];

export const displayHeaders = path => {
  return withHeaders.includes(path);
};

export const RGBAToHexA = ({ r, g, b, a }) => {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);
  a = Math.round(a * 255).toString(16);

  if (r.length == 1) r = '0' + r;
  if (g.length == 1) g = '0' + g;
  if (b.length == 1) b = '0' + b;
  if (a.length == 1) a = '0' + a;

  return '#' + r + g + b + a;
};

export const hexAToRGBA = h => {
  let r = 0,
    g = 0,
    b = 0,
    a = 1;

  if (h.length == 5) {
    r = '0x' + h[1] + h[1];
    g = '0x' + h[2] + h[2];
    b = '0x' + h[3] + h[3];
    a = '0x' + h[4] + h[4];
  } else if (h.length == 9) {
    r = '0x' + h[1] + h[2];
    g = '0x' + h[3] + h[4];
    b = '0x' + h[5] + h[6];
    a = '0x' + h[7] + h[8];
  }
  a = +(a / 255).toFixed(3);
  const color = {
    r,
    g,
    b,
    a,
  };
  return color;
};

export const percentToHex = p => {
  const percent = Math.max(0, Math.min(100, p)); // bound percent from 0 to 100
  const intValue = Math.round((percent / 100) * 255); // map percent to nearest integer (0 - 255)
  const hexValue = intValue.toString(16); // get hexadecimal representation
  return hexValue.padStart(2, '0').toUpperCase(); // format with leading 0 and upper case characters
};

export const hexToPercentage = h => {
  return Math.round((parseInt(h, 16) / 255) * 100);
};
export function runWhenIdle(
  task,
  {
    timeout = 3000,
    abortSignal, // optional AbortController.signal
  } = {}
) {
  let executed = false;
  let rafId = null;
  let timeoutId = null;
  let idleId = null;

  const cleanup = () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (idleId) cancelIdleCallback?.(idleId);
    if (timeoutId) clearTimeout(timeoutId);
  };

  const runOnce = () => {
    if (executed || abortSignal?.aborted) return;
    executed = true;
    cleanup();
    task();
  };

  // 1️⃣ Wait until browser paints at least once
  rafId = requestAnimationFrame(() => {
    // 2️⃣ Run in idle time if possible
    if ('requestIdleCallback' in window) {
      idleId = requestIdleCallback(runOnce, { timeout });
    } else {
      timeoutId = setTimeout(runOnce, timeout);
    }
  });

  // 3️⃣ Hard fallback
  timeoutId = setTimeout(runOnce, timeout);
}
